<template>
  <div id="AppSelect" style="height:calc(100vh);" class="col-12 t-c-v bg-color-primary">
    <div ref="app_head" class="col-12 fixed-t">
      <div class="col-12 lh40 pl5 pr5">
        <div class="col-12 f18" @click="$router.back(-1)"><i class="iconfont icon-31fanhui1 color-white"></i></div>
      </div>
    </div>
    <div class="col-12 t-c">
        <img src="../assets/logo_t.png" class="w15 r5">
        <div class="col-12 t-c-v">
          <div class="w10 h10 bg-color-white r5 pt15 pb10 mr10" @click="go('Main')" v-if="$store.state.app_type != 'Main'">
            <div class="col-12"><i class="iconfont icon-yonghu1 f40 color-primary"></i></div>
            <div class="col-12 f14 color-muted pt10">Usuario</div>
          </div>
          <div class="w10 h10 bg-color-white r5 pt15 pb10 mr10" @click="go('Technician')" v-if="$store.state.app_type != 'Technician'">
            <div class="col-12"><i class="iconfont icon-type-of-work-managem f40 color-primary"></i></div>
            <div class="col-12 f14 color-muted pt10">Técnico</div>
          </div>
          <div class="w10 h10 bg-color-white r5 pt15 pb10" @click="go('Agent')" v-if="$store.state.account.account_grade >= 90 && $store.state.app_type != 'Agent'">
            <div class="col-12"><i class="iconfont icon-qiyeguanli_yuangongguanli f40 color-primary"></i></div>
            <div class="col-12 f14 color-muted pt10">Agente</div>
          </div>
        </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'AppSelect',
  data () {
    return {
    }
  },
  created: function () {

  },
  methods: {
    go: function (path) {
      this.$store.commit('setApp',path);
      this.$router.push({ path: path })
    }
  }
}
</script>


// WEBPACK FOOTER //
// src/components/AppSelect.vue